export default __webpack_public_path__ + "static/media/report_illustration.5229b3fa.svg";